import { api } from '../api';

/**
 * GET /rooms 응답의 보이스 계정 요약
 * 소스: voicecheck.users (voicecheck.admin_room.voice_user_id 조인)
 */
export interface VoiceUserSummary {
  /** voicecheck.users.id */
  id: number;
  /** voicecheck.users.login_id — 태블릿 로그인 ID (발급 시 room{호실번호}) */
  loginId: string;
  /** voicecheck.users.name */
  name: string;
  /** voicecheck.users.status (예: active) */
  status: string;
}

/**
 * 호실 DTO (haha.admin_room + voicecheck.admin_room.voice_user_id)
 * voiceUserId는 호실 태블릿 계정용 — 입소자 개인 매핑과 별개
 */
export interface RoomDto {
  /** haha.admin_room.id (= voicecheck.admin_room.id) */
  id: string;
  /** haha.admin_room.room_number */
  roomNumber: string;
  /** haha.admin_room.floor */
  floor: number;
  /**
   * voicecheck.admin_room.voice_user_id → users.id
   * 미연결 null
   */
  voiceUserId: number | null;
  /** voiceUserId 조인 요약. 삭제/미존재면 null */
  voiceUser: VoiceUserSummary | null;
}

/**
 * 호실 목록 조회 — 입소자 등록 드롭다운용
 * @returns {Promise<RoomDto[]>}
 */
export async function listRooms(): Promise<RoomDto[]> {
  const res = await api.get<RoomDto[]>('/rooms');
  return res.data;
}
